module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('el-container') : _c('el-container', [_c('sidebar', {
    attrs: {
      "collapse": _vm.isCollapse
    }
  }), _vm._v(" "), _c('el-container', {
    staticClass: "wrapper"
  }, [_c('el-header', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    staticClass: "menu-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "lang-selection",
    attrs: {
      "span": 6,
      "hide-on-click": false
    }
  }, [(_vm.isAnalyticsEnabled) ? _c('a', {
    staticClass: "analytics-link",
    attrs: {
      "href": _vm.analytics.href,
      "data-qa": "Header-Analytics-Link",
      "target": _vm.analytics.target
    }
  }, [_c('el-button', [_vm._v("\n              " + _vm._s(_vm.$t(_vm.analytics.text)) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    class: _vm.dropdown.lang.class,
    attrs: {
      "data-qa": "Header-Lang-DropDown",
      "trigger": _vm.dropdown.lang.trigger
    },
    on: {
      "command": _vm.dropdown.lang.command
    }
  }, [_c('el-button', {
    attrs: {
      "data-qa": "Header-Lang-Button"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentLang)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.dropdown.lang.items), function(item) {
    return _c('el-dropdown-item', {
      key: item.text,
      attrs: {
        "command": item.command,
        "data-qa": item['data-qa'],
        "id": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "user-dropdown",
    attrs: {
      "data-qa": "Header-User-DropDown",
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "data-qa": "Header-User-Button"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.username)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "solutionStatusTest",
      "data-qa": "Header-UserDropdown-Item-SolutionStatusTest",
      "id": "solutionStatusTest"
    }
  }, [_vm._v(_vm._s(_vm.$t('dashUserDropDownSolutionTestText')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "signOut",
      "data-qa": "Header-UserDropdown-Item-SignOut",
      "divided": "",
      "id": "signOut"
    }
  }, [_vm._v(_vm._s(_vm.$t('dashUserDropDownSignOutText')))])], 1)], 1)], 1), _vm._v(" "), _c('solution-status-test')], 1)], 1), _vm._v(" "), _c('el-main', [_c('router-view')], 1), _vm._v(" "), _c('el-footer', [_c('div', {
    attrs: {
      "data-qa": "Footer-ExositeCopyRight-Text"
    }
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + "\n        "), _c('a', {
    attrs: {
      "href": _vm.footer.exosite.href,
      "target": _vm.footer.exosite.target,
      "data-qa": "Footer-ExositeCopyRight-Link"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.footer.exosite.text) + "\n        ")]), _vm._v(".\n        " + _vm._s(_vm.$t(_vm.footer.copyRight.text)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "links-group"
  }, [_c('a', {
    attrs: {
      "data-qa": "Footer-Documentation-Link-Documentation",
      "href": _vm.footer.documentation.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.documentation.text)))]), _vm._v(" "), _c('a', {
    attrs: {
      "data-qa": "Footer-Support-Link-Support",
      "href": _vm.footer.support.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.support.text)))]), _vm._v(" "), _c('a', {
    attrs: {
      "data-qa": "Footer-Terms-Link-Terms",
      "href": _vm.footer.terms.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.terms.text)))]), _vm._v(" "), _c('a', {
    attrs: {
      "data-qa": "Footer-Privacy-Link-Privacy",
      "href": _vm.footer.privacy.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.privacy.text)))]), _vm._v(" "), (_vm.hasVersion) ? _c('span', {
    attrs: {
      "data-qa": ("Footer-Version-Link-" + (_vm.footer.version))
    }
  }, [_vm._v(_vm._s(_vm.currentVersion))]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e016e8a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash/Dash.vue
// module id = 970
// module chunks = 3